import axios from "axios";
import configuration from "../configuration/configuration";
import { getDeviceType } from "../container/mppmodal/Utils";

class Services {
  fetchDBUYInfoFromServer(tokenId) {
    return axios
      .get(
        configuration[window._syfMpp_.SYF_MPP_ENV].host1 +
        "/mpp-data/" +
        tokenId
      )
      .catch((error) => {
        return error;
      });
  }

  fetchStatus(syfToken, partnerId) {
    return axios
      .get(
        configuration[window._syfMpp_.SYF_MPP_ENV].host1 +
        "/fetchStatus?syfId=" +
        syfToken +
        "&partnerId=" +
        partnerId
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }

  async checkMsfApplyBuyFlow(syfToken) {
    try {
      const response = await axios.get(configuration[window._syfMpp_.SYF_MPP_ENV].host1 + "/checkMsfApplyBuy?syfToken=" + syfToken);
      return response.data;
    } catch (error) {
      return error;
    }
  }

  async doSeamlessMsfApplyBuy(syfToken) {
    try {
      await axios.get(configuration[window._syfMpp_.SYF_MPP_ENV].host1 + "/msfCheckout?requestOrigin=mpp&syfToken=" + syfToken);
    } catch (error) {
      return error;
    }
  }

  fetchOfferDetails(merchantNumber, amount) {
    return axios
      .post(
        "https://api-offer-service.app.dev.dal.pcf.syfbank.com/offers/lookup",
        {
          merchantNumber,
          amount,
        },
        {
          headers: {
            "X-SYF-Request-channelId": "DD",
            "X-SYF-Request-trackingId": "33456789123",
          },
        }
      )
      .then((response) => {
        return response.data.offerInfo;
      })
      .catch((err) => { });
  }

  fetchMerchantSpecificDetails(
    processInd,
    partnerId,
    amount,
    productCategoryNames,
    productCategoryNames1,
    productCategoryNames2,
    productCategoryNames3,
    transAmount1,
    transAmount2,
    transAmount3,
    syfToken,
    flowType,
    childSyfPartnerId,
    partnerCode,
    childSyfMerchantNumber,
    promoOverRideFlag,
    offerNumber1,
    offerNumber2,
    offerNumber3,
    tokenId,
    transactionToken,
    d2dFlow,
    merchantRefererUrl,
    partnerProfileCode,
    siteCode,
    clientTransId,
    clientName,
    mppApplicationLink,
    authorizationNumber,
    initialCallCompleted,
    widgetWebviewFlag,
    webviewAccessToken,
    syfMerchantNumber,
    channelId,
    orgFlow,
    mppFromAnyWhereFlag,
    acquisitionFlag,
    applyFromAnyWhereFlag,
    payInFourProductConfigured,
    merchantDomainURL,
    productIds1,
    productIds2,
    productIds3
  ) {
    return axios
      .post(
        configuration[window._syfMpp_.SYF_MPP_ENV].host1 +
        "/fetchMerchantSpecificInfo",
        {
          processInd,
          partnerId,
          transAmount1:
            transAmount1 == null
              ? amount?.replace(/^0+/, "")
              : transAmount1?.replace(/^0+/, ""),
          productCategoryNames: productCategoryNames,
          productCategoryNames1: productCategoryNames1,
          productCategoryNames2: productCategoryNames2,
          productCategoryNames3: productCategoryNames3,
          productIds1: productIds1,
          productIds2: productIds2,
          productIds3: productIds3,
          transAmount2: transAmount2,
          transAmount3: transAmount3,
          defaultPromoCode: "",
          syfToken,
          flowType,
          childSyfPartnerId,
          partnerCode,
          childSyfMerchantNumber,
          promoOverRideFlag,
          offerNumber1,
          offerNumber2,
          offerNumber3,
          tokenId,
          transactionToken,
          d2dFlow,
          merchantRefererUrl,
          partnerProfileCode,
          siteCode,
          clientTransId,
          clientName,
          mppApplicationLink,
          authorizationNumber,
          initialCallCompleted,
          widgetWebviewFlag,
          webviewAccessToken,
          syfMerchantNumber,
          orgFlow,
          mppFromAnyWhereFlag,
          acquisitionFlag,
          applyFromAnyWhereFlag,
          payInFourProductConfigured,
          merchantDomainURL
        },
        { headers: { channelId } }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  }

  sendDataToCheckoutApi(
    partnerId,
    pcgc,
    amount,
    syfToken,
    flowType,
    clientName,
    productCategoryNames,
    setPayIn4Info,
    formPostData,
    merchantDomainURL,
    childSyfPartnerId,
    partnerCode,
    d2dFlow,
    childSyfMerchantNumber,
    empqFlag,
    fromEmail,
    sc,
    merchantWebsiteURL,
    empqPaylaterMonthlyFlag,
    merchantRefererUrl,
    partnerProfileCode,
    softapplyEnabled,
    siteCode,
    clientTransId,
    mppFromAnyWhereFlag,
    actionType,
    tokenId,
    operatorId,
    dataShareToken,
    qsDataToCheckoutApi,
    syfMerchantNumber,
    channelId,
    orgFlow,
    adobe_mcvid,
    industryName,
    clientCode,
    acquisitionFlag,
    applyFromAnyWhereFlag,
    d2dSourceChannel,
    uniqueId
  ) {
    const { authorizationNumber = "",
      applicationType = ""
    } = qsDataToCheckoutApi || {}
    return axios
      .post(
        configuration[window._syfMpp_.SYF_MPP_ENV].host1 +
        "/sendDataToCheckoutApi",
        {
          partnerId,
          transAmount1: amount,
          pcgc,
          syfToken,
          flowType,
          clientName,
          productCategoryNames,
          setPayIn4Info,
          formPostData,
          merchantDomainURL,
          childSyfPartnerId,
          partnerCode,
          d2dFlow,
          childSyfMerchantNumber,
          empqFlag,
          fromEmail,
          sc,
          merchantWebsiteURL,
          empqPaylaterMonthlyFlag,
          merchantRefererUrl,
          partnerProfileCode,
          softapplyEnabled,
          siteCode,
          clientTransId,
          mppFromAnyWhereFlag,
          actionType,
          tokenId,
          operatorId,
          dataShareToken,
          authorizationNumber,
          applicationType,
          merchantID: syfMerchantNumber,
          channelId,
          orgFlow,
          acquisitionFlag,
          applyFromAnyWhereFlag,
          adobeMcvid: adobe_mcvid || "",
          industryName: industryName || "",
          clientCode: clientCode || "",
          deviceType: getDeviceType(),
          d2dSourceChannel: d2dSourceChannel || "",
          uniqueId: uniqueId || ""
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error();
      });
  }

  fetchBrandInfo(partnerId, partnerProfileCode, requestFields) {
    return axios
      .post(
        configuration[window._syfMpp_.SYF_MPP_ENV].host1 +
        "/partnerconfiglookup",
        {
          partnerId,
          partnerProfileCode,
          requestFields,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error();
      });
  }

  sendDataToDataShareApi(
    partnerId,
    pcgc,
    amount,
    syfToken,
    flowType,
    clientName,
    productCategoryNames,
    setPayIn4Info,
    formPostData,
    merchantDomainURL,
    childSyfPartnerId,
    partnerCode,
    d2dFlow,
    childSyfMerchantNumber,
    empqFlag,
    fromEmail,
    merchantWebsiteURL,
    empqPaylaterMonthlyFlag,
    tokenId
  ) {
    return axios
      .post(
        configuration[window._syfMpp_.SYF_MPP_ENV].host1 +
        "/sendDataToDataShareApi",
        {
          partnerId,
          transAmount1: amount,
          pcgc,
          syfToken,
          flowType,
          clientName,
          productCategoryNames,
          setPayIn4Info,
          formPostData,
          merchantDomainURL,
          childSyfPartnerId,
          partnerCode,
          d2dFlow,
          childSyfMerchantNumber,
          empqFlag,
          fromEmail,
          merchantWebsiteURL,
          empqPaylaterMonthlyFlag,
          tokenId
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error();
      });
  }

  fetchMppFromD2DLink(payload) {
    const {
      d2dMailId: emailAddress,
      totalAmount: initialPurchaseAmount,
      saleAmount,
      promoCodes,
      promotionalTags,
      ...merchantInfo
    } = payload;
    return axios
      .post(
        configuration[window._syfMpp_.SYF_MPP_ENV].host1 +
        "/applicationLink",
        {
          "applicantInfo": {
            emailAddress,
            initialPurchaseAmount,
            saleAmount
          },
          merchantInfo,
          "strategyInfo": {
          },
          "offers": [
            {
              promoCodes,
              promotionalTags,
            }
          ],
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error();
      });
  }
  qsDecline(declinePayload, quickScreenUserActivity) {
    const {
      authorizationNumber,
      merchantNumber,
      storeNumber,
      clientId,
      syfToken
    } = declinePayload
    return axios.post(
      configuration[window._syfMpp_.SYF_MPP_ENV].host1 +
      "/qsDecline",
      {
        authorizationNumber,
        merchantNumber,
        storeNumber,
        clientId,
        quickScreenUserActivityRequest : quickScreenUserActivity
      },
      {
        headers: {
          "X-SYF-Request-trackingId": syfToken,
        },
      }
    )
      .catch((error) => {
        console.log("Decline Error", error);
      })
  }

  saveQuickScreenUserActivity( quickScreenUserActivity, syfToken ) {
    return axios.post(
      configuration[window._syfMpp_.SYF_MPP_ENV].host1 +
      "/saveQuickScreenUserActivity",
      {
        ...quickScreenUserActivity
      },
      {
        headers: {
          "X-SYF-Request-trackingId": syfToken,
        },
      }
    )
      .catch((error) => {
        console.log("Quick screen user activity Error", error);
      })
  }

}

const services = new Services();

export default services;
